import styled from 'styled-components';
import {
  Button as SonarButton,
  Checkbox as SonarCheckbox,
  Icon,
} from '@appcues/sonar';

export const Button = styled(SonarButton)`
  &[data-state='open'] {
    border-width: var(--border-width-x-small);
    outline: 4px solid var(--background-button-destructive-disabled);
    outline-offset: -4px;
  }
`;

export const FilterBadge = styled.span`
  display: flex;
  position: absolute;
  align-items: center;
  justify-content: center;
  color: var(--color-neutral-0);
  background-color: var(--color-blurple-600);
  border-radius: 50%;
  font-size: 10px;
  height: 16px;
  width: 16px;
  right: -6px;
  top: -6px;
`;

export const ActiveIcon = styled(Icon)`
  width: 8px;
  height: 8px;

  && {
    color: var(--foreground-selected);
  }
`;

export const CheckboxWrapper = styled.div`
  > div:hover {
    background-color: transparent;
  }

  label {
    padding: 0;
  }
`;

export const Checkbox = styled(SonarCheckbox)`
  margin-top: 3px;

  ${Icon} {
    color: var(--color-neutral-0);
  }
`;
